module.exports = __webpack_public_path__ + "static/img/jpm.58e6c551.svg";